﻿import { getRaw } from "./apiShared";
import { getSettings } from "../settingsProvider";

export async function downloadFile(url: string, fileName: string, method?: string, body?: any): Promise<number> {
    const response = await getRaw(url, method, body);

    if (response.status === 200) {
        saveBlobAsFile(await response.blob(), fileName);
    }

    return response.status;
}

export function saveBlobAsFile(blob: Blob, fileName: string) {
    // THE 2021-08-04 Dette er et hack for at få browseren til at downloade en fil der er hentet via et ajax kald
    // til UI API'et. Data fra kaldet sættes ind i et link på siden, et click på linket udføres programmatisk og
    // efter filen er hentet, slettes linket igen
    const tempUrl = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = tempUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    link.parentNode?.removeChild(link);
}

// Two-step download for large export files: first fetches a short-lived download URL from an authenticated endpoint,
// then triggers a native browser download via <a> click. This avoids loading the file into memory (unlike fetch+blob)
// and keeps the storage account behind a firewall (unlike direct SAS URLs).
export async function downloadViaStreamingEndpoint(downloadUrlEndpoint: string, fileName: string): Promise<number> {
    const response = await getRaw(downloadUrlEndpoint);

    if (response.status === 200) {
        const body = await response.json();
        const link = document.createElement("a");
        link.href = getSettings().apiBaseUrl + body.url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
    }

    return response.status;
}
